import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/consumer/Link';
import { data } from './data';

const PDPValuePropsModalUI = ({ itemId }) => {
  const item = data[itemId];
  if (!item) return null;
  return (
    <div className="mt-4">
      {item.rows &&
        item.rows.map(row => (
          <div key={itemId + row.title} className="mb-8">
            <h3 className="text-lg font-bold m-0 text-brand-lightest">
              {row.title}{' '}
              {row.superscript && (
                <span>
                  <sup>{row.superscript}</sup>
                </span>
              )}
            </h3>
            {row.text && (
              <p className="text-sm text-brand-lightest">{row.text}</p>
            )}
          </div>
        ))}

      {item.paras &&
        item.paras.map(para => (
          <p key={itemId + para.slice(0, 5)} className="mt-0 mx-0 mb-4">
            {para}
          </p>
        ))}

      {item.terms && (
        <p className="mt-6 mx-0 mb-0 text-xs text-brand-lightest">
          {item.terms}
        </p>
      )}

      {item.footer && (
        <div className="text-xs text-brand-lightest mt-2 [&_a]:text-brand-lightest [&_a]:font-normal [&_a]:no-underline">
          See our{' '}
          <span className="[border-bottom:1px_solid_#737373]">
            <Link to="/returns/" target="_blank">
              full returns policy
            </Link>
          </span>{' '}
          for more details
        </div>
      )}
    </div>
  );
};

PDPValuePropsModalUI.propTypes = {
  itemId: PropTypes.string,
};

export default PDPValuePropsModalUI;
